import React from "react"
import { string } from "prop-types"
import { sessionApiClient } from "@planningcenter/cc-api-client"
import jQuery from "jquery"
import { SharedFirstNameWarning } from "components/shared/shared_first_name_warning"

const DEFAULT_ERROR_MESSAGE = "Something unexpected happened. Please try again."

function serialize(form) {
  return jQuery(form)
    .serializeArray()
    .reduce((memo, item) => {
      memo[item.name] = item.value
      return memo
    }, {})
}

export default class GuestLoginForm extends React.Component {
  static propTypes = {
    sessionUrl: string.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      errors: [],
      loading: false,
      valid: false,
      firstName: null
    }
  }

  handleNameChange = e => {
    this.setState({ firstName: e.target.value })
    this.handleInputChange(e)
  }

  handleInputChange = _event => {
    this.setState({ valid: this.form.checkValidity() })
  }

  handleFormSubmit = event => {
    event.preventDefault()
    const serializedForm = serialize(event.target, { hash: true })

    const attributes = {
      first_name: serializedForm["person[first_name]"],
      last_name: serializedForm["person[last_name]"],
      email_address: serializedForm["person[email_address]"]
    }

    this.setState({ loading: true, errors: [] })

    sessionApiClient
      .post("/people/v2/guests", {
        data: {
          type: "Guest",
          attributes
        }
      })
      .then(json => {
        const accountCenterId = json.data.id

        Rails.ajax({
          url: this.props.sessionUrl,
          type: "post",
          data: `account_center_id=${accountCenterId}`,
          success: data => {
            window.location.replace(data.redirectUrl)
          },
          error: _error => {
            const error = DEFAULT_ERROR_MESSAGE
            this.setState({ loading: false, errors: [error] })
          }
        })
      })
      .catch(_error => {
        const error = DEFAULT_ERROR_MESSAGE
        this.setState({ loading: false, errors: [error] })
      })
  }

  render() {
    const { errors, loading, valid, firstName } = this.state

    return (
      <div className="login-form--narrow">
        {errors.length > 0 && (
          <div id="error_explanation" className="error-alert alert">
            <p className="mb-1">
              <strong>Uh oh! Looks like there were some problems:</strong>
            </p>
            <ul className="unstyled">
              {errors.map((error, i) => (
                <li key={i}>{error}.</li>
              ))}
            </ul>
          </div>
        )}
        <form onSubmit={this.handleFormSubmit} ref={el => (this.form = el)}>
          <fieldset>
            <div className="mb-2">
              <label htmlFor="person[name]">Name</label>
              <div className="f_1 d-f@md">
                <div className="mb-1 mb-0@md pr-1@md">
                  <input
                    type="text"
                    name="person[first_name]"
                    placeholder="First name"
                    onChange={this.handleNameChange}
                    className="focus-js"
                    autoComplete="off"
                    autoFocus
                    required
                  />
                </div>
                <div className="pl-1@md">
                  <input
                    type="text"
                    name="person[last_name]"
                    placeholder="Last name"
                    onChange={this.handleInputChange}
                    autoComplete="off"
                    required
                  />
                </div>
              </div>
              <SharedFirstNameWarning firstName={firstName} />
            </div>
            <div>
              <label htmlFor="person[email_address]">Email Address</label>
              <input
                type="email"
                name="person[email_address]"
                id="person[email_address]"
                placeholder="you@yours.com"
                onChange={this.handleInputChange}
                required
              />
            </div>

            <div className="ta-c my-3">
              <button
                type="submit"
                className="btn"
                disabled={loading || !valid ? "disabled" : null}
              >
                {loading ? "Continuing..." : "Continue"}
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    )
  }
}
